import Alert from '@amzn/meridian/alert';
import { localize } from './localize';

export default localize(Alert, ['children', 'closeLabel', 'title']);
